<template lang="pug">
  v-container.pa-5(fill-height='', fluid='', grid-list-xl='')
    v-snackbar(v-model='snackbar.snackbar' :color='snackbar.color' :center="true" :timeout='snackbar.timeout' :top="true")
      | {{ snackbar.text }}
      v-btn(dark='' text='' @click='snackbar.snackbar = false')
        | {{$t('payment.general.close')}}
    v-dialog(v-model='confirmationDialogEpayco' persistent max-width='290')
      v-card
        v-card-title.headline
          | Confirmar
        v-card-text Estás seguro de eliminar este plan?. Se verificará si el plan se encuentra creado dentro de la base local.
        v-card-actions
          v-spacer
            v-btn(color='red darken-1' text='' @click='confirmationDialogEpayco = false')
              | Cancelar
            v-btn(color='blue darken-1' text='' @click="validDeleteEpaycoPan")
              | Aceptar
    v-dialog(v-model='confirmationDialogEpaycoDelete' persistent max-width='290')
      v-card
        v-card-title.headline
          | Confirmar
        v-card-text {{msgDeleteEpaycoPlan}} Desea Continuar?.
        v-card-actions
          v-spacer
            v-btn(color='red darken-1' text='' @click='confirmationDialogEpaycoDelete = false')
              | Cancelar
            v-btn(color='blue darken-1' text='' @click="deleteEpaycoPlanSend" :loading="loadingDeleteEpaycoPlan")
              | Aceptar
    v-dialog(v-model='confirmationDialogLocal' persistent max-width='290')
      v-card
        v-card-title.headline
          | Confirmar
        v-card-text Está seguro de eliminar este plan? Se eliminará permanentemente de la base local. Para recuperar este plan se debe realizar a partir de los planes de EPAYCO.
        v-card-actions
          v-spacer
            v-btn(color='red darken-1' text='' @click='confirmationDialogLocal = false')
              | Cancelar
            v-btn(color='blue darken-1' text='' @click="deleteLocalPlanSend" :loading="loadingDeleteLocalPlan")
              | Aceptar
    v-dialog(v-model='dialogEditLocalPlan' max-width='500')
      v-form(ref='formLocalPlan' v-model='validUpdateLocal' lazy-validation='')
        v-card
          v-card-title.headline Editar Plan Local
          v-card-text
            h3 Datos
            v-row
              v-col(cols="12" md="6")
                v-text-field(:rules='[rules.required]' label="Título" type="text" v-model="localPlan.title")
              v-col(cols="12" md="6")
                v-text-field(:rules='[rules.required]' label="Cabecera" type="text" v-model="localPlan.heading")
              v-col(cols="12" md="6")
                v-text-field(:rules='[rules.required]' label="Ícono" type="text" v-model="localPlan.icon")
              v-col(cols="12" md="6")
                v-text-field(:rules='[rules.required]' label="Posición" type="number" min="0" v-model="localPlan.position")
              v-col(cols="12" md="6")
                v-text-field(:rules='[rules.required]' label="Texto" type="text" v-model="localPlan.text")
              v-col(cols="12" md="6")
                v-select(:items='shows', label='Mostrar', v-model='localPlan.show')
            h3 Restricciones
            v-row
              v-col(cols="12" md="6")
                v-text-field(:rules='[rules.required]' label="Colaboradores" type="number" min="0" v-model="localPlan.restrictions.collaborators")
              v-col(cols="12" md="6")
                v-text-field(:rules='[rules.required]' label="Dias de TIENDA VIRTUAL gratis" type="number" min="0" v-model="localPlan.restrictions.freeVirtualShopDays")
              v-col(cols="12" md="6")
                v-text-field(:rules='[rules.required]' label="Puntos de Venta" type="number" min="0" v-model="localPlan.restrictions.salePoints")
              v-col(cols="12" md="6")
                v-text-field(:rules='[rules.required]' label="Tiendas Virtuales" type="number" min="0" v-model="localPlan.restrictions.virtualShops")
            h3 Datos - Plan EPAYCO
              v-row
                v-col(cols="12" md="12")
                  v-text-field(:rules='[rules.required]' label="ID Plan" type="text" disabled="true" v-model="localPlan.id_plan")
                v-col(cols="12" md="6")
                  v-text-field(:rules='[rules.required]' label="Costo" type="text" disabled="true" v-model="localPlan.cost")
                v-col(cols="12" md="6")
                  v-text-field(:rules='[rules.required]' label="Tipo" type="text" disabled="true" v-model="localPlan.type")
          v-card-actions
            v-spacer
            v-btn(color='red darken-1' text='' @click='dialogEditLocalPlan = false')
              | Cancelar
            v-btn(color='green darken-1' text='' :disabled="validPlanToDb()" @click="editLocalPlanSend" :loading="loadingSaveLocalEdit")
              | Guardar
    v-dialog(v-model='dialogEditEpaycoPlan' max-width='500')
      v-form(ref='formEpaycoPlan' v-model='validUpdateEpayco' lazy-validation='')
        v-card
          v-card-title.headline Plan EPAYCO
          v-card-text
            h3 Datos - Plan EPAYCO
              v-row
                v-col(cols="12" md="6")
                  v-text-field(:rules='[rules.required]' label="ID Plan" type="text" :disabled="disabledEpaycoPlan" v-model="epaycoPlan.id_plan")
                v-col(cols="12" md="6")
                  v-text-field(:rules='[rules.required]' label="Nombre" type="text" :disabled="disabledEpaycoPlan" v-model="epaycoPlan.name")
                v-col(cols="12" md="12")
                  v-text-field(:rules='[rules.required]' label="Descripción" type="text" :disabled="disabledEpaycoPlan" v-model="epaycoPlan.description")
                v-col(cols="12" md="6")
                  v-select(:rules='[rules.required]' label="Moneda" :items="currency" :disabled="disabledEpaycoPlan" v-model="epaycoPlan.currency")
                v-col(cols="12" md="6")
                  v-text-field(:rules='[rules.required]' label="Costo" type="number" :disabled="disabledEpaycoPlan" v-model="epaycoPlan.amount")
                v-col(cols="12" md="6")
                  v-select(:rules='[rules.required]' label="Intervalo" :items="intervals" :disabled="disabledEpaycoPlan" v-model="epaycoPlan.interval")
                v-col(cols="12" md="6")
                  v-text-field(:rules='[rules.required]' label="Días Libre" type="number" :disabled="disabledEpaycoPlan" v-model="epaycoPlan.trial_days")
                v-col(cols="12" md="6")
                  v-text-field(:rules='[rules.required]' label="Contador de Intervalo" type="text" :disabled="disabledEpaycoPlan" v-model="epaycoPlan.interval_count")
                v-col(cols="12" md="6")
                  v-text-field(label="Creado" type="text" disabled="true" v-model="epaycoPlan.created")
            <!--h3 Restricciones-->
            <!--v-row-->
              <!--v-col(cols="12" md="6")-->
                <!--v-text-field(label="Colaboradores" type="number" min="0")-->
              <!--v-col(cols="12" md="6")-->
                <!--v-text-field(label="Dias de TIENDA VIRTUAL gratis" type="number" min="0")-->
              <!--v-col(cols="12" md="6")-->
                <!--v-text-field(label="Puntos de Venta" type="number" min="0")-->
              <!--v-col(cols="12" md="6")-->
                <!--v-text-field(label="Tiendas Virtuales" type="number" min="0")-->
          v-card-actions
            v-spacer
            v-btn(color='red darken-1' text='' @click='dialogEditEpaycoPlan = false')
              | Cancelar
            v-btn(color='green darken-1' text='' @click='addNewEpaycoPlanSend' :disabled="disabledEpaycoPlan" :loading="loadingSaveEpaycoPlan")
              | Guardar
    v-layout(wrap='')
      base-material-card(icon='mdi-earth' title='Planes', style='width:100%')
        v-row
          v-col(cols='12' md='12').text-right
            v-btn(small color="success" @click="addNewEpaycoPlan").mx-2
              | Agregar Nuevo Plan
              v-icon mdi-plus
          v-col(cols="12" md="6")
            v-row
              v-col(cols="8")
                h1 Planes de EPAYCO: {{arrApaycoPlans.length}}
              v-col(cols="4").text-right
                v-btn(v-on='on' icon='' color='green' :disabled="progressApaycoPlans" @click="loadPlansEpayco")
                  v-icon(style="font-size: 30px;") mdi-update
            v-progress-linear(indeterminate='' color='green' v-if="progressApaycoPlans")
            v-data-table.data-table-scroll(:headers='headers', :items='arrApaycoPlans', hide-default-footer='', disable-pagination, style="height: 450px; overflow-y: scroll;")
                template
                  v-card-text
                template(v-slot:item.actions="{ item }")
                  v-btn(v-on='on' icon='' color='red' @click="deleteEpaycoPlan(item)")
                    v-icon mdi-delete
                  v-btn(v-on='on' icon='' color='green' @click="openEpaycoPlan(item)")
                    v-icon mdi-eye
                  v-btn(v-on='on' icon='' color='red' @click="epaycoToLocal(item)")
                    v-icon mdi-arrow-right
          v-col(cols="12" md="6")
            v-row
              v-col(cols="12")
                h1 Planes en Base de Datos: {{arrLocalPlans.length}}
            v-progress-linear(indeterminate='' color='green' v-if="progressLocalPlans")
            v-data-table.data-table-scroll(:headers='headersLocal', :items='arrLocalPlans', hide-default-footer='', disable-pagination, style="height: 450px; overflow-y: scroll;")
              template
                v-card-text
              template(v-slot:item.actions="{ item }")
                v-btn(v-on='on' icon='' color='red'  @click="deleteLocalPlan(item)")
                  v-icon mdi-delete
                v-btn(v-on='on' icon='' color='green' @click="editLocalPlan(item)")
                  v-icon mdi-tooltip-edit
</template>
<script>
  export default {
    data () {
      return {
        loadingDeleteEpaycoPlan: false,
        loadingDeleteLocalPlan: false,
        banDeleteEpaycoLocalPlan: false,
        msgDeleteEpaycoPlan: '',
        confirmationDialogEpaycoDelete: false,
        loadingSaveLocalEdit: false,
        loadingSaveEpaycoPlan: false,
        validUpdateLocal: true,
        validUpdateEpayco: true,
        idLocalPlanSelect: null,
        confirmationDialogEpayco: false,
        confirmationDialogLocal: false,
        disabledEpaycoPlan: false,
        progressLocalPlans: false,
        progressApaycoPlans: false,
        dialogEditLocalPlan: false,
        dialogEditEpaycoPlan: false,
        arrLocalPlans: [],
        arrApaycoPlans: [],
        intervals: ['day', 'week', 'month', 'year'],
        currency: ['COP', 'USD'],
        rules: {
          required: value => !!value || 'Requerido',
        },
        headers: [
          {
            sortable: true,
            text: 'Id Plan',
            value: 'id_plan',
            align: 'left',
          },
          {
            sortable: true,
            text: 'Estado',
            value: 'status',
            align: 'left',

          },
          {
            sortable: true,
            text: 'Monto',
            value: 'amount',
            align: 'left',

          },
          {
            sortable: false,
            text: this.$t('payment.general.actions'),
            value: 'actions',
            align: 'left',

          },
        ],
        headersLocal: [
          {
            sortable: true,
            text: 'Id Plan',
            value: 'data.id_plan',
            align: 'left',
          },
          {
            sortable: true,
            text: 'Estado',
            value: 'data.status',
            align: 'left',

          },
          {
            sortable: true,
            text: 'Monto',
            value: 'data.cost',
            align: 'left',

          },
          {
            sortable: true,
            text: 'Tipo',
            value: 'data.type',
            align: 'left',

          },
          {
            sortable: false,
            text: this.$t('payment.general.actions'),
            value: 'actions',
            align: 'left',

          },
        ],
        snackbar: {
          color: '',
          snackbar: false,
          text: '',
          timeout: 6000,
        },
        localPlanSend: {
          id: '',
          data: '',
        },
        localPlan: {
          cost: '',
          heading: '',
          icon: '',
          id_plan: '',
          position: '',
          text: '',
          title: '',
          type: '',
          restrictions: {
            collaborators: '',
            freeVirtualShopDays: '',
            salePoints: '',
            virtualShops: '',
          },
        },
        epaycoPlan: {
          id_plan: '',
          name: '',
          description: '',
          amount: '',
          currency: '',
          interval: '',
          interval_count: '',
          trial_days: '',
          created: '',
        },
        shows: [true, false],
      }
    },
    created () {
      this.loadPlansEpayco()
      this.loadLocalPlans()
    },
    methods: {
      validPlanToDb () {
        const vm = this
        if (
          vm.localPlan.show === undefined ||
          !vm.localPlan.cost ||
          !vm.localPlan.heading ||
          !vm.localPlan.icon ||
          !vm.localPlan.id_plan ||
          !vm.localPlan.position ||
          !vm.localPlan.text ||
          !vm.localPlan.title ||
          !vm.localPlan.type ||
          !vm.localPlan.restrictions.collaborators ||
          !vm.localPlan.restrictions.freeVirtualShopDays ||
          !vm.localPlan.restrictions.salePoints ||
          !vm.localPlan.restrictions.virtualShops
        ) {
          return true
        } else {
          return false
        }
      },
      deleteLocalPlanSend () {
        this.loadingDeleteLocalPlan = true
        this.$store.dispatch('plans/deleteLocalPlan', this.localPlanSend).then(res => {
          this.confirmationDialogLocal = false
          this.loadingDeleteLocalPlan = false
          if (res) {
            this.setDataNotification(true, 'success', 'Plan LOCAL eliminado de manera correcta.')
            this.loadLocalPlans()
          } else {
            this.setDataNotification(true, 'error', 'Error al momento de eliminar el plan LOCAL.')
          }
        }, () => {
          this.confirmationDialogLocal = false
          this.loadingDeleteLocalPlan = false
          this.setDataNotification(true, 'error', 'Error al momento de eliminar el plan LOCAL.')
        })
      },
      deleteLocalPlan (plan) {
        this.confirmationDialogLocal = true
        this.localPlanSend = plan
      },
      deleteEpaycoPlanSend () {
        this.loadingDeleteEpaycoPlan = true
        // if (this.banDeleteEpaycoLocalPlan) {
        this.$store.dispatch('plans/deletePlan', this.epaycoPlan).then(res => {
          this.confirmationDialogEpaycoDelete = false
          this.loadingDeleteEpaycoPlan = false
          if (res.status) {
            this.setDataNotification(true, 'success', 'Plan eliminado de EPAYCO de manera correcta.')
            this.dialogEditEpaycoPlan = false
            const dataLocal = {
              id: this.epaycoPlan.id_plan,
              data: null,
            }
            this.$store.dispatch('plans/deleteLocalPlan', dataLocal).then(() => {
              this.loadLocalPlans()
            })
            this.loadPlansEpayco()
          } else {
            this.setDataNotification(true, 'error', res.data.description)
            this.dialogEditEpaycoPlan = false
          }
        }, () => {
          this.confirmationDialogEpaycoDelete = false
          this.loadingDeleteEpaycoPlan = false
          this.setDataNotification(true, 'error', 'Error al momento de eliminar el plan de EPAYCO.')
          this.dialogEditEpaycoPlan = false
        })
        // }
      },
      deleteEpaycoPlan (plan) {
        this.epaycoPlan = plan
        this.confirmationDialogEpayco = true
      },
      validDeleteEpaycoPan () {
        this.confirmationDialogEpayco = false
        const localPlan = this.arrLocalPlans.filter(item => {
          if (item.data.id_plan === this.epaycoPlan.id_plan) {
            return item
          }
        })
        this.confirmationDialogEpaycoDelete = true
        if (localPlan.length > 0) {
          this.msgDeleteEpaycoPlan = 'El plan se encuentra creado dentro de la base de datos local. Al eliminar el PLAN se eliminará el plan de la base de datos local PERMANENTEMENTE.'
          this.banDeleteEpaycoLocalPlan = false
        } else {
          this.msgDeleteEpaycoPlan = 'El plan no se encuentra creado dentro de la base de datos local.'
          this.banDeleteEpaycoLocalPlan = true
        }
      },
      addNewEpaycoPlanSend () {
        if (this.$refs.formEpaycoPlan.validate()) {
          this.loadingSaveEpaycoPlan = true
          this.$store.dispatch('plans/createPlan', this.epaycoPlan).then(res => {
            if (res) {
              this.setDataNotification(true, 'success', 'Plan creado en EPAYCO de manera correcta.')
              this.dialogEditEpaycoPlan = false
              this.loadingSaveEpaycoPlan = false
              this.loadPlansEpayco()
            } else {
              this.setDataNotification(true, 'error', 'Error al momento de crear el plan en EPAYCO.')
              this.dialogEditEpaycoPlan = false
              this.loadingSaveEpaycoPlan = false
            }
          }, () => {
            this.setDataNotification(true, 'error', 'Error al momento de crear el plan en EPAYCO.')
            this.dialogEditEpaycoPlan = false
            this.loadingSaveEpaycoPlan = false
          })
        }
      },
      editLocalPlanSend () {
        if (this.$refs.formLocalPlan.validate()) {
          this.loadingSaveLocalEdit = true
          const data = {
            id: this.idLocalPlanSelect,
            data: this.localPlan,
          }
          this.$store.dispatch('plans/editLocalPlan', data).then(() => {
            this.dialogEditLocalPlan = false
            this.loadingSaveLocalEdit = false
            this.setDataNotification(true, 'success', 'Actualización realizada de manera correcta.')
            setTimeout(() => {
              this.loadLocalPlans()
            }, 1000)
          }, error => {
            this.loadingSaveLocalEdit = false
            console.log(error)
            this.setDataNotification(true, 'error', 'Error al momento de realizar la actualización.')
          })
        }
      },
      addNewEpaycoPlan () {
        this.dialogEditEpaycoPlan = true
        this.disabledEpaycoPlan = false
        this.epaycoPlan = {
          id_plan: '',
          name: '',
          description: '',
          amount: '',
          currency: '',
          interval: '',
          interval_count: '',
          trial_days: '',
          created: '',
        }
      },
      openEpaycoPlan (plan) {
        this.dialogEditEpaycoPlan = true
        this.disabledEpaycoPlan = true
        this.epaycoPlan = plan
      },
      editLocalPlan (plan) {
        this.dialogEditLocalPlan = true
        this.localPlan = plan.data
        this.idLocalPlanSelect = plan.id
      },
      epaycoToLocal (plan) {
        this.idLocalPlanSelect = plan.id_plan
        this.dialogEditLocalPlan = true
        const localPlan = this.arrLocalPlans.filter(item => {
          if (item.data.id_plan === plan.id_plan) {
            return item
          }
        })
        // console.log(localPlan)
        let icon = ''
        let position = ''
        let title = ''
        let restrictions = {
          collaborators: '',
          freeVirtualShopDays: '',
          salePoints: '',
          virtualShops: '',
        }
        if (localPlan.length > 0) {
          icon = localPlan[0].data.icon
          position = localPlan[0].data.position
          title = localPlan[0].data.title
          restrictions = localPlan[0].data.restrictions
        }
        this.localPlan = {
          cost: plan.amount,
          heading: plan.name,
          icon: icon,
          id_plan: plan.id_plan,
          position: position,
          text: plan.description,
          title: title,
          type: plan.interval,
          restrictions: restrictions,
        }
      },
      loadPlansEpayco () {
        this.progressApaycoPlans = true
        this.$store.dispatch('payment/getAllPlansApayco').then(res => {
          // console.log(res)
          this.progressApaycoPlans = false
          if (res) {
            this.arrApaycoPlans = res.data
          }
        })
      },
      loadLocalPlans () {
        this.progressLocalPlans = true
        this.$store.dispatch('payment/getPlansData').then(res => {
          // console.log(res)
          this.progressLocalPlans = false
          if (res) {
            this.arrLocalPlans = res
          }
        })
      },
      setDataNotification (ban, color, text) {
        this.snackbar.snackbar = ban
        this.snackbar.color = color
        this.snackbar.text = text
      },
    },
  }
</script>
